import axios from '../utils/axios';
import { PAINTING_TYPE_K, paintTabs, K, profession_mode_params } from 'utils/constant/paintingConstant';

/**
 *
 * @doc
 *  https://github.com/mingzhang96/bakamaka/blob/dev-v1/project/api_doc.md#%E8%8E%B7%E5%8F%96%E6%89%80%E6%9C%89%E7%B1%BB%E5%9E%8B%E5%92%8C%E5%AF%B9%E5%BA%94%E7%9A%84tag%E5%92%8C%E5%9B%BE%E7%89%87
 @request
   model_name	string	true	"beta_v0.3.1"	用到的模型名称
   prompt	string	true	"one girl, beautiful"	描述
   neg_prompt	string	true	"unsafe"	反向描述
   n_samples	int	true	4	生成图片的数量
   ddim_steps	int	true	30	生成步数
   scale	float	true	7.0	文本控制力度
   output_size	string	true	"640x640"	选择的图片尺寸
   auto_weight	bool	true	True	自动权重
   select_seed	int	true	0	随机数种子。如果是-1的话代表不指定
 @return
   task_id,	string	"f3e5b59c-7416-11ed-a160-00163e025c94"	任务id
   points,	int	1000	当前用户点数
   today_first_login,	bool	True	是否今天第一次登录
   affordable,	bool	True	是否付得起
   can_work,	bool	True	当前是否可以生成任务（如果任务数量达到上限就变成False
 */
export const paintingPost = (payload) => {
  const tab = paintTabs.find(i => i.value === payload[PAINTING_TYPE_K]);
  const data = {};
  tab.params.forEach(k => {
    data[k] = payload[k];
  });

  // // 非专业模式，删除专业模式对应的参数
  // if (!payload[K.profession_mode]) {
  //   profession_mode_params.forEach(k => {
  //     delete data[k];
  //   });
  // }
  return axios({
    method: 'post',
    url: `/v1/${tab.api.post}`,
    data,
  });
};

export const queryTaskById = ({ task_id, task_type }) => {
  const tab = paintTabs.find(i => i.value === task_type);
  // todo i18n
  if (!tab) return Promise.reject({ code: -1, msg: 'Invalid params' });
  return axios({
    method: 'get',
    url: `/v1/${tab.api.demo}/resume/${task_id}`
  });
};

export const paintingDemo = (type) => {
  const tab = paintTabs.find(i => i.value === type);
  return axios({
    method: 'get',
    url: `/v1/${tab.api.demo}/demo`,
  });
};

/**
 *当前任务队列
 * @request
 *    none
 *  @return
 *    task  list   示例
 *     'task_id': "9edb2f62-77e2-11ed-9aed-00163e025c94",
 *    ' task_type': 'txt2img',
 *     'model_name': "Albedo_V0.3.3",
 *     'prompt': "",
 *     'n_samples': 4,
 *     'ddim_steps': 30,
 *     'scale': 7.0,
 *     'output_size': "640x640",
 *     'fixed_code': True,
 *     'auto_weight': True,
 *     'select_seed': -1,
 *     'images': [
 *                 "https://pic.bakamaka.io/txt2img-result/2022-12-10/31e17f66-788b-11ed-98e2-00163e025c94_00000.jpg",
 *       ],
 *      'state': "done",
 *      'error_msg': "",
 */
export const queueTask = () => {
  return axios({
    method: 'post',
    url: `/v1/get_task_queue`,
  });
};

/**
 *下载图片
 * @request
 *    task_id string 任务id
 *    save_index int 需要下载的图片编号
 *  @return
 *    ret_path  下载地址
 */
export const download_img = ({ task_id, task_type, save_index }) => {
  return axios({
    method: 'post',
    url: `/v1/get_raw_download_path`,
    data: {
      task_id,
      task_type,
      save_index
    }
  });
};

/**
 * https://github.com/mingzhang96/bakamaka/blob/dev-v1/project/api_doc.md#%E4%B8%8A%E4%BC%A0%E5%9B%BE%E7%89%87
 *上传图片
 * @request
 *    task_id string 任务id
 *    save_index int 需要下载的图片编号
 *  @return
 *    ret_path  下载地址
 */
export const upload_img = (data) => {
  return axios({
    method: 'post',
    url: `/v1/upload_img`,
    headers: {
      'Content-Type': "multipart/form-data",
    },
    data,
  });
};

/**
 * 获取用户的文生图任务
 * @request
 *      'page': 1    int    从 1 开始，代表页数，每页的数量是10
 *  @return
 *      'tasks': [
 *         {
 *             'task_id': "", # string 任务id
 *             'images': [
 *                 {
 *                     'middle': "", # 图片路径
 *                     'save_index': 0, # 图片在该task内标号
 *                 }
 *             ],
 *             'prompt': "prompt", # string 这个任务用到的描述
 *             'start_time': "2022-12-12 00:00", 这个任务开始的时间
 *         },
 *         ...
 *     ]
 */
export const get_user_tasks_txt2img = (page) => {
  const data = {}
  data['page'] = page;
  return axios({
    method: 'post',
    url: `/v1/get_user_tasks_txt2img`,
    data
  });
};

/**
 * 获取用户的图生图任务
 * @request
 *      'page': 1    int    从 1 开始，代表页数，每页的数量是10
 *  @return
 *      {
 *     tasks': [
 *         {
 *             'task_id': "", # string 任务id
 *             'images': [
 *                 {
 *                     'middle': "", # 图片路径
 *                     'save_index': 0, # 图片在该task内标号
 *                 }
 *             ],
 *             'prompt': "prompt", # string 这个任务用到的描述
 *             'start_time': "2022-12-12 00:00", 这个任务开始的时间
 *             'init_img': "" # string 任务用到的原图
 *         },
 *         ...
 *     ]
 * }
 */
export const get_user_tasks_img2img = (page) => {
  const data = {}
  data['page'] = page;
  return axios({
    method: 'post',
    url: `/v1/get_user_tasks_img2img`,
    data
  });
};

/**
 * 获取用户的魔改任务
 * @request
 *      'page': 1   int 从 1 开始，代表页数，每页的数量是10
 *  @return
 *    {
 *     'tasks': [
 *         {
 *             'task_id': "", # string 任务id
 *             'images': [
 *                 {
 *                     'middle': "", # 图片路径
 *                     'save_index': 0, # 图片在该task内标号
 *                 }
 *             ],
 *             'prompt': "prompt", # string 这个任务用到的描述
 *             'start_time': "2022-12-12 00:00", 这个任务开始的时间
 *             'init_img': "" # string 任务用到的原图
 *         },
 *         ...
 *     ]
 * }
 */
export const get_user_tasks_inpaint = (page) => {
  const data = {}
  data['page'] = page;
  return axios({
    method: 'post',
    url: `/v1/get_user_tasks_inpaint`,
    data
  });
};


/**
 * 获取用户的收藏任务
 * @request
 *      'page': 1   int 从 1 开始，代表页数，每页的数量是10
 *  @return
 *    {
 *     'tasks': [
 *         {
 *             'task_id': "", # string 任务id
 *             'images': [
 *                 {
 *                     'middle': "", # 图片路径
 *                     'save_index': 0, # 图片在该task内标号
 *                 }
 *             ],
 *             'prompt': "prompt", # string 这个任务用到的描述
 *             'start_time': "2022-12-12 00:00", 这个任务开始的时间
 *             'init_img': "" # string 任务用到的原图
 *         },
 *         ...
 *     ]
 * }
 */


export const get_user_common_imagelist = (page, typemode) => {
  const data = {}
  data['page'] = page;
  console.log(typemode)
  return axios({
    method: 'post',
    url: `/v1/${typemode}`,
    data
  });
}


/**
 * 描述词输入建议
 * @param word
 * @return {*}
 */
export const querySuggestPrompt = (word) => {
  return axios({
    method: 'post',
    url: `/v1/get_suggest_tags`,
    data: {
      word
    }
  }).catch(e => e);
};

/**
 * 删除排队中的任务
 * https://github.com/mingzhang96/bakamaka/blob/dev-v1/project/api_doc.md#%E5%88%A0%E9%99%A4%E6%8E%92%E9%98%9F%E4%B8%AD%E7%9A%84%E4%BB%BB%E5%8A%A1
 * @param task_type
 * @param task_id
 * @return {*}
 */
export const deleteTask = ({ task_type, task_id }) => {
  return axios({
    method: 'post',
    url: `/v1/delete_user_pending`,
    data: {
      task_type,
      task_id,
    }
  }).catch(e => e);
};

export const ConstantPostPointsParams = ['output_size', 'ddim_steps', 'n_samples', K.os_size, K.os_scale, K.profession_mode];
/**
 * data: {
 *   'output_size', 'ddim_steps', 'n_samples'
 * }
 * @param data
 * @return {Promise<AxiosResponse<any>>}
 */
export const queryPostPoints = (data) => {
  const invalidParams = ConstantPostPointsParams.slice(0, 2).find(i => !data[i]);
  if (invalidParams) return Promise.reject({});
  return axios({
    method: 'post',
    url: `/v1/get_cost_points`,
    data
  }).catch(e => e);
};

/**
 * 描述词随机生成
 * @return {*}
 */
export const queryRandomPrompt = () => {
  return axios({
    method: 'get',
    url: `/v1/get_random_prompt`,
  });
};


/**
 * 点击分享按钮, 分享到gallery. 每张图片只能分享一次, 无法重复分享, 分享后无法取消, 用户只能分享自己任务生成的图片
 *
 * "task_type": "txt2img", # string 类型，范围是 ['txt2img', 'img2img', 'inpaint']
 * "task_id": "f3e5b59c-7416-11ed-a160-00163e025c94", # string 任务id
 * "save_index": 0, # int 图片的标号
 * @return {*}
 */
export const share_img = ({ task_id, task_type, save_index }) => {
  return axios({
    method: 'post',
    url: `/v1/share_img`,
    data: {
      task_type,
      task_id,
      save_index
    }
  });
};

/**
 * 这里收藏指的是收藏整个task，而不是针对某一张生成图片进行收藏。收藏数量也会有上限
 *
 * "task_type": "txt2img", # string 类型，范围是 ['txt2img', 'img2img', 'inpaint']
 * "task_id": "f3e5b59c-7416-11ed-a160-00163e025c94", # string 任务id
 * 'fav': True, # bool 如果是True表示是点击收藏，如果是False表示取消收藏
 * @return {*}
 */
export const favorite = ({ task_id, task_type, fav }) => {
  return axios({
    method: 'post',
    url: `/v1/favorite`,
    data: {
      task_type,
      task_id,
      fav
    }
  });
};


/**
 * 广场接口
 * 'page': 1, # int 页数
 * @return
 * 'tasks': [
 *         {
 *             'task_id': "", # string 任务id
 *             'task_type': "", # string 任务类型
 *             'save_index': 0, # 图片在该task内标号
 *             'image_path': "", # 图片路径
 *             'user_name': 'name', # list 这个任务用到的描述
 *             'start_time': "2022-12-12 00:00", 这个任务开始的时间,
 *         },
 *         ...
 *     ],
 *     'per_page': 20, # 每页数量
 */
export const get_gallery = (page) => {
  return axios({
    method: 'post',
    url: `/v1/get_gallery`,
    data: {
      page
    }
  });
};


/**
 * 比赛接口
 * 'page': 1, # int 页数
 * @return
 * 'tasks': [
 *         {
 *             'task_id': "", # string 任务id
 *             'task_type': "", # string 任务类型
 *             'save_index': 0, # 图片在该task内标号
 *             'image_path': "", # 图片路径
 *             'user_name': 'name', # list 这个任务用到的描述
 *             'start_time': "2022-12-12 00:00", 这个任务开始的时间,
 *         },
 *         ...
 *     ],
 *     'per_page': 20, # 每页数量
 */
export const get_gallery_match = (page) => {
  return axios({
    method: 'post',
    url: `/v1/get_gallery_match`,
    data: {
      page
    }
  });
};



/**
 * 比赛投稿
 *  "task_type": "txt2img", # string 类型，范围是 ['txt2img', 'img2img', 'inpaint']
 *  "task_id": "f3e5b59c-7416-11ed-a160-00163e025c94", # string 任务id
 *  "save_index": 0, # int 图片的标号
 * @return
 *    'result': True, # bool 表示投稿成功
 */
export const join_match = (page) => {
  return axios({
    method: 'post',
    url: `/v1/join_match`,
    data: {
      task_id: page.task_id,
      task_type: page.task_type,
      save_index: page.save_index
    }
  });
};
